import Http from '@/services/httpCommunity'

export const getCommunitySearchHistoryStats = () => Http.get('/search-histories/stats')
export const getCommunitySearchHistoryList = params =>
	Http.get('/search-histories/fetch', { params })
